import type { Theme } from '@modules/Layout/Default/Sidebar/Navbar/types';
import { keyframes } from 'styled-components';

// Apply same collpased state to all sidebar sub-components to be able to
// properly apply the sliding animation.
// To have the sliding animation working properly, we always render the sidebar
// as expanded while it is transitioning, shriking the elements when it is
// collapsing or expanding the elements when it is expanding.
export function getRenderSidebarCollapsed(
  sidebarCollapsed: boolean,
  sidebarTransitionEnded: boolean,
) {
  return sidebarTransitionEnded ? sidebarCollapsed : false;
}

export const ANIMATION_DURATION = 350;

export const ANIMATION_TIMING_FUNCTION = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

// Animate the button size between sidebar modes
// scale values are based on the difference between the icon size
// of the sidebar collapsed and expanded
export const expandAnimationIcon = keyframes`
  from {
    transform: scale(0.833);
  }

  to {
    transform: scale(1);
  }
`;
export const collapseAnimationIcon = keyframes`
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0.833);
  }
`;

// Group here the values of the CSS properties that affect the final height of the list of links
export const LINK_HEIGHT = 40;
export function getListItemMarginTop(theme: Theme) {
  return theme.spacing?.xs;
}

// Encapsulate the logic to calculate the height of the list of links
export function getNavigationMenuHeight(listLength: number, theme: Theme) {
  return (
    listLength *
    (LINK_HEIGHT + Number.parseInt(getListItemMarginTop(theme) ?? '', 10))
  );
}

export function animateNavigationMenu(height: number, collapse: boolean) {
  return collapse
    ? keyframes`
  from {
    max-height: ${height}px;
  }

  to {
    max-height: 0;
  }
`
    : keyframes`
  from {
    max-height: 0;
  }

  to {
    max-height: ${height}px;
  }
`;
}

// Animate the footer of the sidebar between sidebar modes
// Slide horizontally to the final position
export const expandAnimationFooter = keyframes`
  from {
    transform: translateX(-4.5px);
  }

  to {
    transform: translateX(0);
  }
`;
export const collapseAnimationFooter = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-4.5px);
  }
`;
